module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/iiW2aa/tc-custom/9781439676233.jpg?1737196545544",
      "alt": "This image is the cover for the book Growing Up in Fairfield, California"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Growing Up in Fairfield, California\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A magic nostalgia ride awaits."), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("Life in Fairfield in the decades after World War II was an unparalleled experience. From cruising down Texas Street on weekends to catching a carnival in the Wonder World parking lot, fond memories of long-lost times haven't been forgotten. People flocked to vintage eateries like Joe's Buffet and Smorga Bob's, and played on the rocket ship slide at Allan Witt Park. Roller Rinks like the M&M Skateway hosted not just skaters, but dances featuring Fats Domino and Roy Orbison. Commuters hopped aboard the FART bus to save on gas, and frequenting Dave's Giant Hamburgers was a rite of passage."), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("Longtime Daily Republic journalist and accidental historian Tony Wade takes a deep dive into the Fairfield of yesteryear.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tony Wade\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Tony Wade came to Fairfield in 1976 when he was twelve and never left. He attended Grange Intermediate, Armijo High School and Solano Community College. In 2006, Wade began writing columns for the local newspaper, the Daily Republic. In 2011, he became an amateur historian when he began the \"Back in the Day\" columns for the Daily Republic. He is the elder brother of longtime Daily Republic columnist Kelvin Wade and lives in Fairfield with his wife, Beth, and their Chiweenie, Chunky Tiberius.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0